/**
 * class: Button's class name    string
 *     options: "btn", "btn st01"
 * style: Button's style    object
 * name: Button's name    string
 * onClick: Button's click event    function
 * disabled: Button's disabled    boolean
 *
 */

import React from "react";
/** Components Import */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function BasicButton({
  btnClass,
  style,
  name,
  onClick,
  disabled,
  icon,
  hidden,
}) {
  const ButtonPress = () => {
    onClick();
  };

  return (
    <button
      className={"btn " + btnClass}
      style={style}
      onClick={ButtonPress}
      disabled={disabled}
      hidden={hidden}
    >
      {icon ? <FontAwesomeIcon icon={icon} /> : null}
      {name}
    </button>
  );
}

BasicButton.defaultProps = {
  class: "",
  disabled: false,
};

export default BasicButton;
